import { FetcherList } from '@garpix/fetcher/fetcher-list/react-router'
import { dataStates } from '@garpix/fetcher'
import TournamentCard from '@/components/Cards/TournamentCard'
import Container from '@/components/Container'
import Section from '@/components/Section'
import Title from '@/components/Title'
import WantToHoldChamp from '@/components/WantToHoldChamp'
import { usePage } from '@/hooks'
import React from 'react'
import Filters from './components/Filters'
import style from './styles/tournaments.module.scss'
import { api } from '@/api'
import { IFetcherListResults } from '@/interfaces/Fetcher'
import { IChampionship } from '@/interfaces/Championship'
import BlockSpinner from '@/components/Spinner/BlockSpinner'
import Button from '@/components/Button'
import { STAGE_TYPE } from '../TournamentsDetail/const'
import NoSearchResults from '@/components/NoSearchResults'
import HtmlContent from '@/components/HtmlContent'

const Tournaments = (): React.ReactElement => {
  const page = usePage()

  const { object } = page?.init_state
  const { config } = page?.init_state?.global

  const tournamentsDetail = config.tournaments_detail ?? ''
  return (
    <>
      <Container>
        <Title type='h1' className={style.tourn__title}>
          {object.title}
        </Title>
        {object !== null ? <HtmlContent className={style.desc} content={object.detail} /> : null}
        <FetcherList
          initFilter={{ page_size: 10 }}
          isScrollTop={false}
          isHistoryPush={false}
          api={api.getTournaments}
        >
          {({
            results,
            status,
            showMore,
            loadData,
            filterParams,
            isNext
          }: IFetcherListResults<IChampionship[]>) => {
            return (
              <Section>
                <Filters handleFilter={loadData} initFilters={filterParams} />
                {status === dataStates.loaded && results.length === 0
                  ? (
                    <NoSearchResults />
                    )
                  : null}
                {results.length > 0
                  ? (
                    <ul className={style.tourn_list}>
                      {results.map((item) => {
                        const stage =
                        item.property_tournament_stage_value === null
                          ? '1'
                          : item.property_tournament_stage_value
                        return (
                          <li key={item.id} className={style.tourn__item}>
                            <TournamentCard
                              title={item.name}
                              description={item.preview_text ?? ''}
                              date={item.date_create}
                              url={`${tournamentsDetail}?element_id=${item.id}`}
                              finished={item.property_is_finished_value}
                              registerClosed={
                              item.property_tourney_register_closed_value
                            }
                              stage={STAGE_TYPE[stage].title}
                            />
                          </li>
                        )
                      })}
                    </ul>
                    )
                  : null}
                {status === dataStates.loading ? <BlockSpinner /> : null}
                {isNext
                  ? (
                    <Button
                      disabled={status === dataStates.loading}
                      onClick={showMore}
                      size='large'
                      wide
                      outline
                    >
                      Показать еще
                    </Button>
                    )
                  : undefined}
              </Section>
            )
          }}
        </FetcherList>
      </Container>

      <WantToHoldChamp
        title='Узнай больше о киберспортивном турнире по обучающей компьютерной игре «ЖЭКА»'
        blueButtonText='Положение о турнире'
      />
    </>
  )
}

export default Tournaments
